
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ImageCropper extends Vue {
  @Prop() file!: File;
  @Prop() showSize!: boolean; // 是否展示裁剪区域的尺寸
  @Prop({ default: true }) showModel!: boolean; // 是否展示弹窗model

  cutShow = false;
  computedStyle = {
    // 裁剪框的样式
    width: "",
    height: "",
    top: "",
    left: ""
  };
  canvasSize = {
    // 展示的canvas的尺寸信息
    width: 437,
    height: 437
  };
  canvasRect = {
    // 展示的canvas的rect信息，用于统一坐标系
    left: 0,
    top: 0
  };
  mousedownInfo = {
    // 鼠标按下时裁剪框的初始信息
    width: 202,
    height: 437,
    left: 117,
    top: 0,
    right: 0
  };
  trendInfo = {
    // 鼠标移动时裁剪框的实时信息
    left: 117,
    top: 0,
    width: 202,
    height: 437
  };
  realCtx: any = null; // 真实用于裁剪的canvas的context
  startResize = false; // 开始调整大小
  startDrag = false; // 开始拖拽
  xSign = 0;
  ySign = 0;
  imageType = "";
  base64 = "";
  resize = {
    offsetX: 0,
    offsetY: 0
  };
  visual: HTMLCanvasElement | null = null;
  visualCtx: CanvasRenderingContext2D | null = null;
  raf: number | null = null;
  debounce: number | null = null;
  scale = 0;

  bigImg = false;
  showCanvas = false;

  @Watch("file")
  onChange(file: File) {
    this.init();
    this.bigImg = file.size > 1000 * 1024 * 2;
    this.imageType = file.type;
    createImageBitmap(file).then(res => {
      this.cutShow = true;
      this.showCanvas = true;
      this.$nextTick(() => {
        this.visual = document.getElementById("visual") as HTMLCanvasElement;
        this.visualCtx = this.visual.getContext("2d");
        const canvas = this.setCanvas(res);
        const r = canvas.getBoundingClientRect();
        this.canvasRect.left = r.left;
        this.canvasRect.top = r.top;
        this.cut();
      });
    });
  }

  init() {
    this.computedStyle = {
      width: "",
      height: "",
      top: "",
      left: ""
    };
    this.mousedownInfo = {
      width: 202,
      height: 437,
      left: 117,
      top: 0,
      right: 0
    };
    this.trendInfo = {
      left: 117,
      top: 0,
      width: 202,
      height: 437
    };
  }

  dragCut(e: any) {
    if (e.button === 0) {
      this.startDrag = true;
      this.resize.offsetX = e.clientX - this.canvasRect.left;
      this.resize.offsetY = e.clientY - this.canvasRect.top;
      this.xSign = this.ySign = 1;
    }
  }

  resizeCut(e: any, xSign?: number, ySign?: number) {
    if (e.button === 0) {
      document.body.style.cursor = e.target.dataset.cursor;
      const cutRect = e.target.parentElement.getBoundingClientRect();
      this.mousedownInfo.left = cutRect.left - this.canvasRect.left;
      this.mousedownInfo.top = cutRect.top - this.canvasRect.top;
      this.mousedownInfo.right = cutRect.right - this.canvasRect.left;
      this.startResize = true;
      this.xSign = this.ySign = 0;
      this.xSign = xSign || 0;
      this.ySign = ySign || 0;
    }
  }

  mounted() {
    window.addEventListener("mousemove", this.handleMouseMove, true);
    window.addEventListener("mouseup", this.handlemouseUp);
  }

  beforeDestroy() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("mouseup", this.handlemouseUp);
  }

  handleMouseMove(e: any) {
    if (this.raf) return;
    this.raf = requestAnimationFrame(() => {
      const {
        left: initLeft,
        top: initTop,
        right: initRight,
        width: initWidth,
        height: initHeight
      } = this.mousedownInfo;
      const { left: canvasLeft, top: canvasTop } = this.canvasRect;
      const { width: canvasWidth, height: canvasHeight } = this.canvasSize;
      if (this.startDrag) {
        // 拖拽，只改变位置不改变大小
        const needChangeLeft = e.clientX - canvasLeft - this.resize.offsetX;
        this.computedStyle.left =
          Math.min(
            Math.max(initLeft + needChangeLeft, 0),
            canvasWidth - initWidth
          ) + "px";
        this.trendInfo.left = Math.min(
          Math.max(initLeft + needChangeLeft, 0),
          canvasWidth - initWidth
        );
        const needChangeTop = e.clientY - canvasTop - this.resize.offsetY;
        this.computedStyle.top =
          Math.min(
            Math.max(initTop + needChangeTop, 0),
            canvasHeight - initHeight
          ) + "px";
        this.trendInfo.top = Math.min(
          Math.max(initTop + needChangeTop, 0),
          canvasHeight - initHeight
        );
      }
      if (this.startResize) {
        // xSign为0时说明当前在拖动的是右面的角
        // ySign为0时说明当前在拖动的是下面的角
        // 固定比例下只计算width与left，height根据width按比例改变，top根据height等价改变
        const maxGrowWidth = this.xSign ? initLeft : canvasWidth - initRight; // 剩余可放大宽度
        const maxGrowHeight = this.ySign
          ? initTop
          : canvasHeight - initTop - initHeight; // 剩余可放大高度
        const maxGrowWidthByHeight = Math.round((maxGrowHeight * 375) / 812); // 根据剩余可放大的高度计算的可放大宽度
        const maxGrow = this.xSign
          ? -Math.min(maxGrowWidth, maxGrowWidthByHeight)
          : Math.min(maxGrowWidth, maxGrowWidthByHeight); // 最多放大的最终值
        const mouseMoveDistance =
          e.clientX - canvasLeft - (this.xSign ? initLeft : initRight); // 移动的距离，向右为正，向左为负
        const widthChangeValue = this.xSign
          ? -Math.max(Math.min(mouseMoveDistance, initWidth), maxGrow)
          : Math.max(Math.min(mouseMoveDistance, maxGrow), -initWidth); // 宽度变化值
        this.trendInfo.width = Math.max(initWidth + widthChangeValue, 20);
        this.computedStyle.width = this.trendInfo.width + "px";
        this.trendInfo.height = Math.floor((this.trendInfo.width * 812) / 375); // 小数会导致高度少了一像素，所以计算top时需要高度向下取整
        if (this.ySign) {
          // 裁剪框的top需要改变
          this.trendInfo.top = initTop + (initHeight - this.trendInfo.height);
          this.computedStyle.top = this.trendInfo.top + "px";
        }
        if (this.xSign) {
          // 裁剪框的left需要改变
          this.trendInfo.left =
            initLeft +
            Math.max(Math.min(mouseMoveDistance, initWidth), maxGrow);
          this.computedStyle.left = this.trendInfo.left + "px";
        }
      }
      if (this.startDrag || this.startResize) {
        if (this.bigImg) {
          if (this.debounce) clearTimeout(this.debounce);
          this.debounce = setTimeout(() => {
            this.cut();
            this.debounce = null;
          }, 200);
        } else {
          this.cut();
        }
      }
      this.raf = null;
    });
  }

  handlemouseUp() {
    this.mousedownInfo.left = this.trendInfo.left;
    this.mousedownInfo.top = this.trendInfo.top;
    this.mousedownInfo.width = this.trendInfo.width;
    this.mousedownInfo.height = this.trendInfo.height;
    this.mousedownInfo.right = 0;
    this.resize.offsetX = 0;
    this.resize.offsetY = 0;
    this.startResize = false;
    this.startDrag = false;
    document.body.style.cursor = "";
  }

  cut() {
    const imageData = this.realCtx?.getImageData(
      this.trendInfo.left / this.scale,
      this.trendInfo.top / this.scale,
      this.trendInfo.width / this.scale,
      this.trendInfo.height / this.scale
    ) as ImageData;
    if (this.visual && this.visualCtx) {
      this.visual.width = imageData.width;
      this.visual.height = imageData.height;
      this.visualCtx.clearRect(0, 0, imageData.width, imageData.height);
      this.visualCtx.putImageData(imageData, 0, 0);
      const base64 = this.visual.toDataURL(this.imageType);
      this.base64 = base64;
    } else {
      this.$emit("error", "未找到用于绘制的canvas节点");
    }
  }

  handleConfirm() {
    this.$emit("confirm", this.base64);
    this.cutShow = false;
  }

  handleCancel() {
    this.cutShow = false;
  }

  setCanvas(imageBitmap: ImageBitmap) {
    console.log(this.canvasSize, imageBitmap);
    const wScale = this.canvasSize.width / imageBitmap.width;
    const hScale = this.canvasSize.height / imageBitmap.height;
    let dx = 0,
      dy = 0;
    if (wScale < hScale) {
      // 竖向居中，总高度 - 图片高度 * 缩放比例，居中除2，由于有缩放最终的值还需要除缩放的比例
      dy = (this.canvasSize.height - imageBitmap.height * wScale) / 2 / wScale;
    } else {
      dx = (this.canvasSize.width - imageBitmap.width * hScale) / 2 / hScale;
    }
    const scale = Math.min(wScale, hScale);
    this.scale = scale;
    // 展示的带model的canvas，进行了缩放，直接截会失真
    const showCanvas = document.getElementById("canvas") as HTMLCanvasElement;

    const ctx = showCanvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.fillStyle = "#F7F8FA";
    ctx.fillRect(0, 0, this.canvasSize.width, this.canvasSize.height);
    ctx?.scale(scale, scale);
    ctx?.drawImage(imageBitmap, dx, dy, imageBitmap.width, imageBitmap.height);

    // 裁剪框内显示高亮的内容
    const lightCanvas = document.getElementById(
      "lightCanvas"
    ) as HTMLCanvasElement;
    const lightCtx = lightCanvas.getContext("2d") as CanvasRenderingContext2D;
    lightCtx.fillStyle = "#F7F8FA";
    lightCtx.fillRect(0, 0, this.canvasSize.width, this.canvasSize.height);
    lightCtx?.scale(scale, scale);
    lightCtx?.drawImage(
      imageBitmap,
      dx,
      dy,
      imageBitmap.width,
      imageBitmap.height
    );

    // 真实截的canvas
    const realcanvas = document.createElement("canvas");
    realcanvas.width = this.canvasSize.width / this.scale;
    realcanvas.height = this.canvasSize.height / this.scale;
    this.realCtx = realcanvas.getContext("2d") as CanvasRenderingContext2D;
    this.realCtx.fillStyle = "#F7F8FA";
    this.realCtx.fillRect(
      0,
      0,
      this.canvasSize.width / this.scale,
      this.canvasSize.height / this.scale
    );
    this.realCtx?.drawImage(
      imageBitmap,
      dx,
      dy,
      imageBitmap.width,
      imageBitmap.height
    );
    return showCanvas;
  }
}
